<template>
  <div class="money">
    <div class="money-left">
      <div style="height: 46px;  border-bottom: 1px solid #cccccc;"></div><!--用来使撑开顶部的，用margin会有滚动条所以用的opacity这种方式-->
      <div class="towNav">
        <router-link to="/money/renew">
          <div class="aside-menu-item mynav" :class="index === 0? 'active':''" @click="onCurrent(0)">
            <img src="/web/static/images/v2/auth/dilatation.png"/><span>设备续费</span>
          </div>
        </router-link>
      </div>
      <div class="towNav">
        <router-link to="/money/dilatation">
          <div class="aside-menu-item mynav" :class="index === 1? 'active':''" @click="onCurrent(1)">
            <img src="/web/static/images/v2/auth/renew.png"/><span>空间扩容</span>
          </div>
        </router-link>
      </div>
      <div class="towNav">
        <router-link to="/money/orderList">
          <div class="aside-menu-item mynav" :class="index === 2? 'active':''" @click="onCurrent(2)">
            <img src="/web/static/images/v2/auth/orderList.png"/><span>订单列表</span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="money-right">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

  export default {
    name: "index",
    mounted() {

    },
    data() {
      return {
        index: 0
      }
    },
    methods: {
      onCurrent(val) {
        this.index = val
      },
    }
  }
</script>

<style scoped lang="scss">
  .money {
    width: 100%;
    height: 100%;
    display: flex;
    background: #dddddd;

    .money-left {
      width: 236px;
      background: #2b3a4f;
      height: 100%;

      .aside-menu-item {
        /*background: #c0c4c3;*/
        height: 45px;
        line-height: 40px;
        width: 100%;
        color: #fff;
        cursor: pointer;
        text-align: left;
        padding-left: 35px;
        box-sizing: border-box;
        border-bottom: 1px solid #606c7c;
      }

      .active {
        background: #3b4c68;
        color: #fff;
      }

      .aside-menu-item:hover {
        background: #3b4c68;
        color: #fff;
      }

      .aside-menu-item img {
        height: 25px;
        margin-left: 15px;
        margin-right: 20px;
        display: inline-block;
        vertical-align: middle;
      }

      .aside-menu-item span {
        font-size: 13px;
        display: inline-block;
        vertical-align: middle;
      }
    }

    .money-right {
      width: calc(100% - 236px);
      padding-bottom: 15px;
      box-sizing: border-box;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/money/index.vue